import { Component, OnInit, Input } from '@angular/core';
import { GlobalDataService } from '../../services/global-data.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  @Input() isOpen: boolean = false;

  data: any = [];
  visible: boolean = false;
  treeMenu: boolean = false;
  permissions: any = [];

  click() {
    this.treeMenu = !this.treeMenu;
  }



  constructor(private global: GlobalDataService) {
    
    this.visible = this.find('sadmin', this.global.user.roles) || false;

    this.data = [
      //  {
      //   type: 0,
      //   name: 'cashbox',
      //   value: 'Касса',
      //   icon: 'fa fa-archive',
      //   link: 'cashbox',
      // visible: this.visible
      // },
      // {
      //   sort: 0,
      //   type: 0,
      //   name: 'notifications',
      //   value: 'Уведомление',
      //   icon: 'fa fa-bell',
      //   link: 'notification',
      //   visible: this.visible
      // },
      {
        sort: 1,
        type: 0,
        name: 'operation',
        value: 'Заявки',
        icon: 'fa fa-asl-interpreting',
        link: 'operation',
        visible: this.visible
      },
      {
        sort: 2,
        type: 0,
        name: 'receipt',
        value: 'Поступлении',
        icon: 'fa fa-download',
        link: 'receipt',
        visible: this.visible
      },
      {
        sort: 3,
        type: 0,
        name: 'sale',
        value: 'Продажи',
        icon: 'fa fa-cart-plus',
        link: 'sale',
        visible: this.visible
      },
      {
        sort: 8,
        type: 0,
        name: 'currency_rate',
        value: 'Курс валюты',
        icon: 'fa fa-line-chart',
        link: 'currency-rate',
        visible: this.visible
      },
      {
        sort: 4,
        type: 0,
        name: 'contractor',
        value: 'Компании',
        icon: 'fa fa-users',
        link: 'contractor',
        visible: this.visible
      },
      {
        sort: 5,
        type: 0,
        name: 'contact',
        value: 'Контакты',
        icon: 'fa fa-male',
        link: 'contact',
        visible: this.visible
      },
      {
        sort: 6,
        type: 0,
        name: 'user',
        value: 'Пользователи',
        icon: 'fa fa-user',
        link: 'user',
        visible: this.visible
      },
      {
        sort: 7,
        type: 0,
        name: 'product_storage',
        value: 'Склады',
        icon: 'fa fa-database',
        link: 'product_storage',
        visible: this.visible
      },
      {
        sort: 8,
        type: 0,
        name: 'tariff',
        value: 'Тарифный план',
        icon: 'fa fa-gift',
        link: 'product-tarif',
        visible: this.visible
      },
      {
        sort: 4,
        type: 0,
        name: 'news',
        value: 'Новости',
        icon: 'fa fa-file',
        link: 'news',
        visible: this.visible
      },
      {
        sort: 9,
        type: 0,
        name: 'role',
        value: 'Права доступа',
        icon: 'fa fa-key',
        link: 'role',
        visible: this.visible
      },
      {
        sort: 10,
        type: 0,
        name: 'report',
        value: 'Отчеты',
        icon: 'fa fa-book',
        link: 'report',
        visible: this.visible
      },

    
      
      
     
      // {
      //   type: 0,
      //   name: 'account',
      //   value: 'Баланс контрактора',
      //   icon: 'fa fa-money',
      //   link: 'account',
      // visible: this.visible
      // },  
     
      //    {
      //   type: 0,
      //   name: 'contractor-type',
      //   value: 'Тип контрактора',
      //   icon: 'fa fa-user',
      //   link: 'contractor-type',
      // visible: this.visible
      // }, 

     



      
      
      // {
      //   type: 0,
      //   name: 'store',
      //   value: 'Хранилище',
      //   icon: 'fa fa-university',
      //   link: 'store'  ,
      // visible: this.visible
      // },
     
      // {
      //   type: 0,
      //   name: 'store-type',
      //   value: 'Типы хранилищи',
      //   icon: 'fa fa-simplybuilt',
      //   link: 'store-type'  ,
      //   visible: this.visible
      // },


      //  {
      //   type: 0,
      //   name: 'manufacture',
      //   value: 'Производитель',
      //   icon: 'fa fa-codepen',
      //   link: 'manufacture'  ,
      // visible: this.visible
      // },


      {
        sort: 11,
        type: '1',
        name: 'references',
        value: 'Отчеты',
        icon: 'fa fa-gear',
        link: 'setting',
        visible: this.visible,
        childes: [
          {
            sort: 0,
            type: 0,
            name: 'product',
            value: 'Товары',
            icon: 'fa fa-product-hunt',
            link: 'product',
            visible: this.visible
          },
          {
            sort: 1,
            type: 0,
            name: 'unit',
            value: 'Ед. измерении',
            icon: 'fa fa-certificate',
            link: 'unit',
            visible: this.visible
          },
          {
            sort: 2,
            type: 0,
            name: 'category',
            value: 'Категории',
            icon: 'fa fa-sitemap',
            link: 'category',
            visible: this.visible
          },
          {
            sort: 3,
            type: 0,
            name: 'tariff_name',
            value: 'Название тарифов',
            icon: 'fa fa-gift',
            link: 'tarif-name',
            visible: this.visible
          },
          
          {
            sort: 5,
            type: 0,
            name: 'cell',
            value: 'Отсеки',
            icon: 'fa fa-stop',
            link: 'cell',
            visible: this.visible
          },
          {
            sort: 6,
            type: 0,
            name: 'position',
            value: 'Должности',
            icon: 'fa fa-graduation-cap',
            link: 'position',
            visible: this.visible
          },
        
          {
            sort: 7,
            type: 0,
            name: 'currency',
            value: 'Валюты',
            icon: 'fa fa-money',
            link: 'currency',
            visible: this.visible
          },
        
          {
            sort: 9,
            type: 0,
            name: 'zone',
            value: 'Страна',
            icon: 'fa fa-building',
            link: 'country',
            visible: this.visible
          },
          {
            sort: 10,
            type: 0,
            name: 'zone',
            value: 'Регион',
            icon: 'fa fa-building',
            link: 'region',
            visible: this.visible
          },
          {
            sort: 11,
            type: 0,
            name: 'zone',
            value: 'Город',
            icon: 'fa fa-building',
            link: 'city',
            visible: this.visible
          },
          {
            sort: 12,
            type: 0,
            name: 'transaction_purpose_type',
            value: 'Назначения проводки',
            icon: 'fa fa-stop',
            link: 'transaction-purpose-type',
            visible: this.visible
          },
          {
            sort: 13,
            type: 0,
            name: 'ownership_type',
            value: 'Формы собственностей',
            icon: 'fa fa-user',
            link: 'ownership-type',
            visible: this.visible
          },
         
        ]
      }

      //  {
      //   type: 0,
      //   name: 'expense',
      //   value: 'Расходы',
      //   icon: 'fa fa-key',
      //   link: 'expense'  ,
      //  visible: this.visible
      // },
      //  {
      //   type: 0,
      //   name: 'expense-type',
      //   value: 'Типы Расходов',
      //   icon: 'fa fa-key',
      //   link: 'expense-type'  ,
      //  visible: this.visible
      // },

      // {
      //   type: 0,
      //   name: 'operation-type',
      //   value: 'Тип операции',
      //   icon: 'fa fa-ravelry',
      //   link: 'operation-type'  ,
      //  visible: this.visible
      // }

    ];


  }


  ngOnInit() {

    if (!this.visible) {
      for (var item of this.global.user.roles) {
        this.checkPermission(item.permissions);
      }
    }

  }

  checkPermission(permissions: any[]) {

    this.data = this.data.map(value => {
      if (value.name == "references") {
        return {
          type: '1',
          name: 'references',
          value: 'Отчеты',
          icon: 'fa fa-gear',
          link: 'setting',
          visible: value.visible || this.find(value.name, permissions),
          childes: value.childes.map(value => {
            return {
              type: value.type,
              name: value.name,
              value: value.value,
              icon: value.icon,
              link: value.link,
              visible: value.visible || this.find(value.name+"-section", permissions)
            }
          })
        }
      } else {
        return {
          type: value.type,
          name: value.name,
          value: value.value,
          icon: value.icon,
          link: value.link,
          visible: value.visible || this.find(value.name+"-section", permissions)
        }
      }
    });

  }

  find(what: string, where: any[]) {
    for (var item of where) {
      if (item.name == what) {
        return true;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/sidebar/sidebar.component.ts